import React, { useContext, useEffect, useState } from "react";

import { Separator } from "@upstageai/ui";

import { FilePreviewItem } from "./FilePreviewItem";
import {
  INDUSTRY_TYPE_LABELS,
  INDUSTRY_TYPE_ORDER,
} from "../../constants/Samples";
import { ValidatorFileContext } from "../../hooks/useFile";
import {
  SamplesByIndustry,
  useSampleFileLoader,
} from "../../hooks/useSampleFileLoader";
import { Sample } from "../../types/sample";
import { endpointStore } from "../../utils/mobx/EndpointStore";
import { cn } from "../../utils/style";

const FileGroupDivider = () => {
  return <Separator orientation="vertical" className="h-[68px] self-end" />;
};

// 프리뷰 포함된 파일 리스트 컴포넌트
export const SampleFilePreviewList = () => {
  const { endpointType } = endpointStore;
  const { getSamplesGroupedByIndustry, selectSampleFile } =
    useSampleFileLoader();
  const [groupedSamples, setGroupedSamples] = useState<SamplesByIndustry>();

  const { files, selectedFileIndex, setSelectedFileIndex, setFiles } =
    useContext(ValidatorFileContext);

  useEffect(() => {
    const samples = getSamplesGroupedByIndustry(endpointType);
    setGroupedSamples(samples);
  }, [endpointType, getSamplesGroupedByIndustry]);

  const handleSampleClick = async (sample: Sample) => {
    await selectSampleFile({
      sample,
      endpointType,
      files,
      actions: {
        setSelectedFileIndex,
        setFiles,
      },
    });
  };

  // 샘플 없으면 렌더링 하지 않음
  if (!groupedSamples) {
    return null;
  }

  return (
    <div className={cn("flex items-center justify-start gap-2")}>
      {/* 샘플 파일을 IndustryType별로 그룹화하여 렌더링 */}
      {INDUSTRY_TYPE_ORDER.map(industryType => {
        const industrySamples = groupedSamples?.[industryType];
        if (!industrySamples?.length) return null;

        return (
          <div className="mb-4 flex gap-2" key={industryType}>
            <FileGroupDivider />
            <div className="flex flex-col gap-1">
              <div className="detail whitespace-nowrap text-muted-foreground">
                {INDUSTRY_TYPE_LABELS[industryType]}
              </div>
              <div className="flex gap-2">
                {industrySamples.map(sample => (
                  <FilePreviewItem
                    key={sample.id}
                    fileName={sample.title}
                    docType={sample.documentInfo?.docType}
                    source={sample.documentInfo?.source}
                    thumbnailSrc={sample.thumbnailPath}
                    isSelected={sample.id === files[selectedFileIndex]?.id}
                    onClick={() => handleSampleClick(sample)}
                  />
                ))}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
